<div class="is-flex is-justify-content-space-between is-align-items-center bg-white p-3">
  <img src="/logoACS.png" alt="logo acs" class="is-hidden-desktop logo logo-mobile ml-4" />
  <img src="/logoACS.png" alt="logo acs" class="is-hidden-touch logo logo-desktop ml-4" />
  <div class="is-flex is-flex-direction-column">
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <button
        mat-fab
        aria-label="Contacts"
        class="is-hidden-desktop is-shadowless"
        (click)="openDialog()">
        <mat-icon [ngStyle]="{ transform: 'scale(1.2)'}">perm_phone_msg</mat-icon>
      </button>
      <div class="is-hidden-touch is-flex mt-3">
        <div class="is-flex mr-3">
          <mat-icon class="rounded">mail_outlined</mat-icon>
          <a class="header-label" href="mailto:contact@acs-ami.com">contact&#64;acs-ami.com</a>
        </div>
        <div class="is-flex mr-3">
          <mat-icon class="rounded">call_outlined</mat-icon>
          <a class="header-label" href="tel:+33140479100">+33 (0)1 40 47 91 00</a>
        </div>
      </div>
      <mat-form-field class="width-6rem ml-2 header-form" appearance="outline">
        <mat-select
          [value]="$language()"
          (selectionChange)="languageChange($event.value)">
          <mat-select-trigger>
            <div class="is-display-flex is-gap-0.5 is-align-items-center">
              <span class="fi fi-{{ $language() === 'fr' ? 'fr' : 'gb' }}"></span>
              {{ $language() | uppercase }}
            </div>
          </mat-select-trigger>
          <mat-option value="fr"><div class="is-display-flex is-gap-0.5"><span class="fi fi-fr"></span>FR</div></mat-option>
          <mat-option value="en"><div class="is-display-flex is-gap-0.5"><span class="fi fi-gb"></span>EN</div></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mr-2 has-text-right">
      @if ($code()) {
        <span> {{ 'key.partner.code' | translate }}: {{ $code() }}</span>
      }
    </div>
  </div>
</div>
